import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError } from "../../utils/api.types";

import {
    IBankResponse,
    IBankFormInputs,
    IBanks,
    IBankUpdatePayload,
    IBank
} from "../../utils/bank.types";

/**
 * Fetch Banks async thunk.
*/
export const fetchBanks = createAsyncThunk(
    'bank/fetchBanks',
    async (accountId: string): Promise<IBanks> => {
        const response = await axios.get(`/api/v1/account/bankaccounts/${accountId}`);

        return response.data;
    }
);

export const selectedBankID = createAction("bank/selectedBankID", (bankId) => {
    return {
        type: 'bank/selectedBankID',
        payload: bankId
    }
});

/**
 * Fetch Banks async thunk.
*/
export const fetchBankById = createAsyncThunk(
    'bank/fetchBankById',
    async (id: string): Promise<IBank> => {
        const response = await axios.get(`/api/v1/account/bankaccount/${id}`);
        return response.data.bank;
    }
);

/**
 * Add Bank async Thunk.
 */
export const addBank = createAsyncThunk(
    'bank/addBank',
    async (bankPayload: IBankFormInputs): Promise<IBankResponse> => {
        const response = await axios.post(`/api/v1/account/bankaccount`, bankPayload);

        return response.data
    }
);

/**
 * Update Bank async Thunk.
 */
export const updateBank = createAsyncThunk<
    IBankResponse,
    IBankUpdatePayload,
    {
        rejectValue: IError,
    }
>(
    'bank/updateBank',
    async ({ id, bankPayload }: IBankUpdatePayload, thunkApi) => {
        try {
            const response = await axios.put(`/api/v1/account/bankaccount/${id}`, bankPayload);

            const { data } = response;

            if (response.status === 200) {
                return data;
            }

            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
    }
);

/**
 * Delete Bank async Thunk.
 */
export const deleteBank = createAsyncThunk(
    'bank/deleteBank',
    async (id: string): Promise<IDeleteApiResponse> => {
        const response = await axios.delete(`/api/v1/account/bankaccounts/${id}`);

        response.data['id'] = id;

        return response.data
    }
);

